import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_DE.json';
import guides from './MEDITATION_GUIDES_DE.json';

export const MEDITATION_DATA_DE: ServiceData = {
  audios,
  guides,
};
